import script from "./ProgrammeOnline23June.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgrammeOnline23June.vue?vue&type=script&setup=true&lang=js"

import "./ProgrammeOnline23June.vue?vue&type=style&index=0&id=5248a2f8&lang=css"

const __exports__ = script;

export default __exports__